import { useContext } from "react";
import {
  DeploymentAccessContext,
  type DeploymentAccessContextValue,
} from "./deployment-access-context";

export function useDeploymentAccess(): DeploymentAccessContextValue {
  const context = useContext(DeploymentAccessContext);
  if (!context) {
    throw new Error("useDeploymentAccess must be used within DeploymentAccessProvider");
  }
  return context;
}
